import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import Rodal from 'rodal';
import 'rodal/lib/rodal.css';

import MessageBox from './MessageBox';
import { antenneConfig, messagesOfflineConfig } from '../../config';

function Carousel(props) {
  const { messages, carousel, setNotifications, languages, settings } = props;

  const [isModalDisplayed, setModalDisplayed] = useState(false);
  const [modalMessage, setModalMessage] = useState(null);

  let moveX = 0;

  const show = (message) => {
    if (message) setModalMessage(message);
    setModalDisplayed(true);
  };

  const hide = () => {
    setModalDisplayed(false);
  };
  useEffect(() => {
    const resize = document.querySelector("#resize");
    const left = document.querySelector(".offline");
    const right = document.querySelector(".antenne");
    const body = document.querySelector("body");

    const tabs = document.querySelectorAll(".tabsCarousel>.nav li");

    moveX =
      left.getBoundingClientRect().width +
      resize.getBoundingClientRect().width / 2;

    let drag = false;

    function mouseDownHandler() {
      drag = true;
    };

    function mouseMoveHandler(e) {
      if (drag) {
        if (e.x > 150) {
          moveX = e.x;

          const leftWidth = moveX - resize.getBoundingClientRect().width / 2;
          left.style.width =
            `${leftWidth}px`;

          right.style.width = `${window.innerWidth - left.getBoundingClientRect().width}px`;

          tabs.forEach(el => {
            const element = el;
            element.style.width = `${leftWidth / settings.tabs_qty}px`;
          })
        }
      }
    };

    function mouseUpHandler() {
      drag = false;
    };

    resize.addEventListener("mousedown", mouseDownHandler);
    body.addEventListener("mousemove", mouseMoveHandler);
    body.addEventListener("mouseup", mouseUpHandler);
  }, []);
  return (
    <div className="flex h-full  carousel" data-status={`carousel_${carousel.type}`}>
      <Rodal height={200} visible={isModalDisplayed} showCloseButton={false} onClose={() => { }}>
        <div className="ok-modal-container">
          <p className='modal-message'>{modalMessage ?? "Une liste antenne active ne peut être vide. Pour supprimer le message, passer le carrousel en OFF."}</p>
          <button onClick={hide} type="button" className="ok-modal-button">OK</button>
        </div>
      </Rodal>
      <MessageBox
        carousel={carousel}
        title={messagesOfflineConfig.title}
        columns={messagesOfflineConfig.columns}
        messages={messages.filter((msg) => !msg.isLive)
          .sort(
            (a, b) => Date.parse(b.createdDate) - Date.parse(a.createdDate)
          )}
        list={messagesOfflineConfig.list}
        type="offline"
        options={{ play: true }}
        hideActiveButton
        hideUrgentStatus={carousel.type !== 1}
        setNotifications={setNotifications}
        className="w-1/4 z-0 bg-zinc-600 offline"
        showOkPopup={show}
        languages={languages}
        settings={settings}
      />
      <div className="resize" id="resize" />
      <MessageBox
        carousel={carousel}
        title={antenneConfig.title}
        type="antenne"
        columns={antenneConfig.columns}
        messages={messages.filter((msg) => msg.isLive).sort(
          (a, b) => b.createdDate - a.createdDate,
        )}
        options={{ antenne: true }}
        list={antenneConfig.list}
        hideOptionalButton
        hideUrgentStatus
        setNotifications={setNotifications}
        className="w-full z-10 bg-zinc-600 antenne"
        showOkPopup={show}
        languages={languages}
      />
    </div>
  );
}

Carousel.propTypes = {
  messages: PropTypes.array,
  carousel: PropTypes.object,
  languages: PropTypes.array,
  setNotifications: PropTypes.func,
  settings: PropTypes.object
};

Carousel.defaultProps = {
  languages: [],
  messages: [],
  carousel: {},
  setNotifications: () => { },
  settings: {}
};

export default Carousel;
